import { React } from 'Imports';
import { getSplitUserAttributes, isSplitTreatmentOn, splitTreatmentNames, TypedSplitTreatments } from '$Utilities/split-io-sdk';
import { ISplitTreatmentsChildProps } from '@splitsoftware/splitio-react/types/types';
import { VideoEventDetailsPage } from '$Pages/VideoEventDetails/VideoEventDetails';
import { VideoEventsPage } from '$Pages/VideoEvents/VideoEvents';
import useExtractEventId from '$Utilities/hooks/useExtractEventId';
import VideoEventHeaderSubText from '$Components/Shared/VideoEventHeaderSubText';
import { useLocation } from 'react-router-dom';
import { useVideoEventNavigation } from '$Utilities/hooks/useVideoEventNavigation';
import { CircularProgress } from 'MaterialUIComponents';
import { ConfigService } from '$State/ConfigFreezerService';

export const VideoEventsRoute = () => {
    const { onSelectVideoEvent } = useVideoEventNavigation();
    const location = useLocation();
    const eventId = location.state?.eventId;
    const subText = VideoEventHeaderSubText();
    const extractEventId = useExtractEventId(eventId);

    // Check both location.search and location.hash for eventId
    const searchParam = ConfigService.isRunningGeotabIntegrated() ? location.hash : location.search;
    const delimiter = ConfigService.isRunningGeotabIntegrated() ? ',eventId:' : '?eventId=';
    const selectedEventId = extractEventId(searchParam, delimiter);

    return selectedEventId ? (
        renderVideoEventDetails(selectedEventId, false, onSelectVideoEvent, subText)
    ) : (
        <TypedSplitTreatments
            names={[
                splitTreatmentNames.showInactiveVehicles,
                splitTreatmentNames.showInactiveDrivers,
                splitTreatmentNames.videoEventCompanyLevels,
            ]}
            attributes={getSplitUserAttributes()}
        >
            {({ treatments, isReady, isTimedout }: ISplitTreatmentsChildProps) => {
                if (!isReady && !isTimedout) return <CircularProgress />;

                const isShowInactiveVehiclesSplitOn = isSplitTreatmentOn(treatments[splitTreatmentNames.showInactiveVehicles]);
                const isShowInactiveDriversSplitOn = isSplitTreatmentOn(treatments[splitTreatmentNames.showInactiveDrivers]);
                const isCompanyLevelSplitOn = isSplitTreatmentOn(treatments[splitTreatmentNames.videoEventCompanyLevels]);

                return (
                    <VideoEventsPage
                        onSelectVideoEvent={onSelectVideoEvent}
                        isShowInactiveVehiclesSplitOn={isShowInactiveVehiclesSplitOn}
                        isShowInactiveDriversSplitOn={isShowInactiveDriversSplitOn}
                        isCompanyLevelSplitOn={isCompanyLevelSplitOn}
                    />
                );
            }}
        </TypedSplitTreatments>
    );
};

const renderVideoEventDetails = (
    selectedEvent: string,
    isVideoRecall: boolean,
    onSelectVideoEvent: (value: string, goBack: boolean, addHistoryState?: boolean) => void,
    subText: string,
) => {
    return (
        <VideoEventDetailsPage
            eventId={selectedEvent}
            onSelectVideoEvent={onSelectVideoEvent}
            isVideoRecall={isVideoRecall}
            subText={subText}
        />
    );
};
